// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2l5oA","consentsList":"PatientConsents_consentsList__adt46","consentsListEmpty":"PatientConsents_consentsListEmpty__35GjL"};